import React from 'react';
import InsuranceServices from './InsuranceServices/';
import PartnerServices from './PartnerServices/';
import EmmaModalView from '../../../../components/EmmaModalView/EmmaModalView';
import MarketPlaceNews from './MarketPlaceNews';
import AxaNews from './AxaNews';
//TODO for VHIS intro modal
import VhisModalView from '../../../axagoal/components/VhisModalView/';
// import BannerModalView from '../../../../modules/emma-notices/components/BannerModalView/';
import EmmaModalTNC from '../../../../components/EmmaModalTNC/';
import EBFlexiBannerView from '../../../../components/EBFlexiBanner/EBFlexiBannerView';
import './styles.scss';
import EmmaTncStyleModel from '../../../../components/EmmaModalView/TncStyleModel/EmmaTncStyleModel';
import HealthKeeperModalView from '../../../../components/EmmaModalView/HealthKeeperModal/HealthKeeperModalView';
import AktivoModalView from '../../../aktivo-onboarding/components/AktivoModalView';
import { connect } from 'react-redux';
import { isCWP } from '../../selectors/serviceSelectors';

import { getFeatureLimitedWeb } from '../../../../selectors/configSelectors';
import { EBDownloadBanner } from '../../../../components/EBDownloadBanner';
import { FeatureLimitedWebInfo } from 'src/reducers/appReducer';
import { EmmaSpace } from '@axa-asia/emma-stylesheet';

export interface HomeScreenLayoutProps {
  featureLimitedWeb: FeatureLimitedWebInfo;
}
export class HomeScreenLayout extends React.Component<HomeScreenLayoutProps> {
  constructor(props: any = {}) {
    super(props);
  }
  render() {
    return (
      <div className="homepage-wrapper">
        <div>
          <EBFlexiBannerView />
        </div>
        {this.props.featureLimitedWeb
          ?.showLimitedWebPortalPolicySelectionBanner && (
          <div className={EmmaSpace.mb24}>
            <EBDownloadBanner />
          </div>
        )}
        <div>
          <InsuranceServices />
        </div>
        <div>
          <PartnerServices />
        </div>
        <div>
          <MarketPlaceNews />
        </div>
        <div>
          <AxaNews />
        </div>
        {/* {!isCwp && <div><div><AxaNews /></div><div><MarketPlaceNews /></div></div>}
        {!!isCwp && <div><div><MarketPlaceNews /></div><div><AxaNews /></div></div>} */}
        <EmmaModalView />
        <AktivoModalView />
        <VhisModalView />
        {/* <BannerModalView /> */}
        <EmmaModalTNC />
        <EmmaTncStyleModel />
        <HealthKeeperModalView />
      </div>
    );
  }
  static mapStateToProps(state: any, ownProps: any) {
    return {
      featureLimitedWeb: getFeatureLimitedWeb(state),
    };
  }
}
export default connect(HomeScreenLayout.mapStateToProps)(HomeScreenLayout);
